<template>
  <el-dialog class="dialog-detail-container" @close="handleClose" title="充值消费明细" :visible.sync="dialogVisible">
    <div class="v-member-info">
      <div class="v-member-photo">
        <img :src="memberInfo.wxheadurl" />
      </div>
      <div class="v-member-base">
        <div>昵称：{{memberInfo.wxname}}</div>
        <div>ID：{{memberInfo.mid}}</div>
      </div>
      <div class="v-member-base">
        <div>姓名：{{memberInfo.name}}</div>
        <div>生日：{{memberInfo.birthday}}</div>
        <div>手机：{{memberInfo.mobile}}</div>
      </div>
      <div class="v-member-recharge">
        <el-button @click="handleRecharge" size="medium" type="primary">现金充值</el-button>
      </div>
    </div>
    <div class="v-member-decollator">
      <div class="v-member-decollato-left">
        <span>消费次数：{{memberInfo.spendtimes}} 次</span>
        <span>累计消费：{{memberInfo.spendamount}} 元</span>
        <span>充值次数：{{memberInfo.rechargetimes}} 次</span>
        <span>累计充值：{{memberInfo.rechargeamount}} 元</span>
      </div>
      <div class="v-member-decollato-right">
        <span>充值消费记录 <i class="el-icon-caret-bottom"></i></span>
      </div>
    </div>
    <div class="v-member-money">
    </div>
    <div class="v-member-container">
      <el-scrollbar>
        <el-table :data="tableData" stripe highlight-current-row :show-header="false">
          <el-table-column>
            <template slot-scope="scope">
              <span class="recordtype-plus" v-if="scope.row.recordtype=='20' || scope.row.recordtype=='21'">- {{ scope.row.amount }}</span>
              <span class="recordtype-subtract" v-else>+ {{ scope.row.amount }}</span> 元
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span>{{changeRecordtype(scope.row.recordtype)}} {{ scope.row.amount }} 元</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span>余额 {{ scope.row.balance }} 元</span><br />
              <span>{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span>{{ scope.row.shop_name }} </span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
import { getRecords } from '@/views/webpc/MemberManagement/MemberList/apis'
export default {
  data () {
    return {
      dialogVisible: false,
      tableData: [],
      memberInfo: {}
    }
  },
  methods: {
    // 获取方式转换
    // 10在线充值，11后台现金充值，12后台刷卡充值，13后台其他充值，20余额支付，21后台扣款
    changeRecordtype (status) {
      status = parseInt(status)
      switch (status) {
        case 10:
          return '在线充值'
        case 11:
          return '后台现金充值'
        case 12:
          return '后台刷卡充值'
        case 13:
          return '后台其他充值'
        case 20:
          return '余额支付'
        case 21:
          return '后台扣款'
        default:
          return '其他'
      }
    },
    handleRecharge () {
      this.$router.push({ path: '/cashRecharge', query: { mid: this.memberInfo.mid } })
    },
    show (obj) {
      this.memberInfo = obj
      this.getRecordsDetail(obj.mid)
      this.dialogVisible = true
    },
    // 查看充值消费明细
    getRecordsDetail (mid) {
      let data = new FormData()
      data.append('mid', mid)
      getRecords(data)
        .then(result => {
          if (result) {
            this.tableData = result.data.list
          }
        })
    },
    handleClose () {
      setTimeout(() => {
        this.tableData = []
        this.memberInfo = {}
      }, 200)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/webpc/MemberManagement/MemberList/modules/DetailModal.vue